import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import { displayToast } from "../../components/app/AppToast";
import ContentHeader from "../../components/app/headers/ContentHeader";
import { reloadCurrentUser } from "../../domains/user/hooks/useCurrentUser";
import { apiClient, useApiRevalidate } from "../../services/api";
import { ClientError } from "../../../../api/src/shared/request";
import ScrollableLayout from "../../components/layout/ScrollableLayout";
import { useTranslation } from "react-i18next";
import { gaPushEvent } from "../../tools/analytics/base.analytics";

export default function ProfileCreatePlaylist() {
  const history = useHistory();
  const { t } = useTranslation();
  const revalidate = useApiRevalidate();
  const [playlistName, setPlaylistName] = useState("");
  const [isPending, setIsPending] = useState(false);

  async function handleCreate() {
    if (playlistName.length > 0) {
      try {
        setIsPending(true);
        await apiClient.post("/webapp/private/playlists", {
          json: { title: playlistName },
        });
        gaPushEvent("playlist_created", {
          origin: "profile",
          title: playlistName,
        });
        await revalidate("/webapp/private/playlists/me");
        displayToast(
          t("Collection created. Added to your profile."),
          "success"
        );
        await reloadCurrentUser();
        history.goBack();
      } catch (error) {
        if (error instanceof ClientError && error.responseStatus === 409) {
          displayToast(
            t(
              "🥺 This playlist title already exists. Give it a unique sweet name."
            ),
            "error"
          );
        } else {
          displayToast(t("Something went wrong. Please try again."), "error");
        }
      } finally {
        setIsPending(false);
      }
    } else {
      displayToast(
        t("🖖 Name this beautiful playlist. Pick something that sticks!"),
        "warning"
      );
    }
  }

  return (
    <ScrollableLayout
      headerClassName="bg-white/90 backdrop-blur-md"
      header={
        <ContentHeader
          transparent
          title={playlistName.length > 0 ? playlistName : t("My new playlist")}
        />
      }
    >
      <div className="p-[30px]">
        <Input
          placeholder={t("Create new playlist")}
          value={playlistName}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
            setPlaylistName(e.target.value);
          }}
        />
        <hr style={{ margin: "30px 0" }} />
        <Button
          variant="primary"
          size="lg"
          className="w-full"
          disabled={isPending}
          onClick={handleCreate}
        >
          {t("Create")}
        </Button>
      </div>
    </ScrollableLayout>
  );
}
